<template>
  <div>
    <div class="search-wrapper">
      <div class="search-item">
        <span>项目编号：</span>
        <Input style="width:200px;" v-model="searchValue.projectFull"></Input>
      </div>
      <div class="search-item">
        <span>项目简编：</span>
        <Input style="width:160px;" v-model="searchValue.projectShort"></Input>
      </div>
      <div class="search-item">
        <span>质疑单位：</span>
        <Input style="width:200px;" v-model="searchValue.questionCompany"></Input>
      </div>
      <Button type="primary" @click="search" style="margin: 0 10px;">搜索</Button>
      <Button type="primary" @click="newRegister">添加</Button>
    </div>
    <Table :columns="columns" :data="registerData"></Table>
    <Page :total="total" :current="currentPage" show-elevator show-total @on-change="pageChange"></Page>
    <Modal title="质疑登记" v-model="registerVisible" width="800">
      <questionForm ref="questionForm" :selectRegister="selectRegister"></questionForm>
      <div slot="footer">
        <Button @click="registerVisible=false">取消</Button>
        <Button @click="createOrUpdate" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { formatDate } from '@/lib/tool'
import QuestionForm from './questionForm'

export default {
  name: 'questionRegister',
  components: {
    QuestionForm
  },
  data() {
     return {
       columns: [
         {
           title: '质疑项目编号',
           width: 155,
           render: (h, params) => {
             return h('div', params.row.clProject.projectFull)
           }
         },
         {
           title: '质疑单位',
           key: 'questionCompany'
         },
         {
           title: '收到时间',
           width: 100,
           render: (h, params) => {
             let time = '未填写'
             if (params.row.receiveTime) {
               time = formatDate(params.row.receiveTime).split(' ')[0]
             }
             return h('div', time)
           }
         },
         {
           title: '答复时间',
           width: 100,
           render: (h, params) => {
             let time = '未填写'
             if (params.row.responseTime) {
               time = formatDate(params.row.responseTime).split(' ')[0]
             }
             return h('div', time)
           }
         },
         {
           title: '质疑阶段',
           width: 100,
           key: 'questionStage'
         },
         {
           title: '处理结果',
           key: 'results'
         },
         {
           title: '操作',
           width: 110,
           render: (h, params) => {
             return h('div', [
               h('Button', {
                 props: {
                   size: 'small',
                   type: 'primary'
                 },
                 on: {
                   click: () => {
                     this.selectRegister = params.row
                     this.registerVisible = true
                   }
                 }
               }, '详情/编辑')
             ])
           }
         }
       ],
       registerData: [],
       total: 0,
       currentPage: 1,
       searchValue: {
         questionCompany: '',
         projectFull: '',
         projectShort: ''
       },
       registerVisible: false,
       selectRegister: {}
     }
  },
  created() {
    this.getRegister(1, this.searchValue)
  },
  methods: {
    async createOrUpdate() {
      const inputResult = this.$refs.questionForm.getResult()
      if (inputResult.questionCompany === '' || inputResult.receiveTime === '' || inputResult.projectId === '') {
        this.$Message.info('请填写完整信息')
        return
      }
      try {
        this.$Spin.show()
        let rep = await ajax.post(requestUrls.ClQuestion.CreateOrUpdate, {
          clQuestion: inputResult
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.$Message.success('操作成功')
          this.registerVisible = false
          this.getRegister(1, this.searchValue)
        }
      } catch(err) {
        this.$Spin.hide()
        this.$Message.error('操作失败')
        console.error(err)
      }
    },
    async getRegister(page, { questionCompany = '', projectFull = '', projectShort = '' }) {
      let questionCompanyFilter = questionCompany ? ` and question.questionCompany.contains("${questionCompany}")` : ''
      let projectFullFilter = projectFull ? ` and project.projectFull.contains("${projectFull}")` : ''
      let projectShortFilter = projectShort ? ` and project.projectShort.contains("${projectShort}")` : ''
      let filter = questionCompanyFilter + projectFullFilter + projectShortFilter
      filter = filter.slice(5)
      let rep = await ajax.get(requestUrls.ClQuestion.GetPaged, {
        params: {
          filter: filter,
          sorting: 'question.id desc',
          maxResultCount: 10,
          skipCount: (page - 1) * 10
        }
      })
      if (rep.data.success) {
        this.currentPage = page
        this.total = rep.data.result.totalCount
        this.registerData = rep.data.result.items
      }
    },
    // 创建新质疑登记
    async newRegister() {
      this.$refs.questionForm.clearRegister()
      this.registerVisible = true
    },
    pageChange(page) {
      this.getRegister(page, this.searchValue)
    },
    search() {
      this.getRegister(1, this.searchValue)
    }
  }
}
</script>

<style lang="less" scoped>
.search-wrapper {
  margin: 5px 0;
  .search-item {
    display: inline-block;
    margin-right: 5px;
  }
}
</style>
